
document.addEventListener('DOMContentLoaded', function(){
  // Dock: all items neutral. Tap gives temporary premium feedback only.
  document.querySelectorAll('.aura-mobile-dock a').forEach(function(a){
    a.classList.remove('active');
    a.removeAttribute('aria-current');
    a.addEventListener('pointerdown',function(){
      a.classList.add('pb-tap');
      window.setTimeout(function(){a.classList.remove('pb-tap')},420);
    });
  });

  // Scroll reveals.
  var reveal = document.querySelectorAll('.pb-reveal');
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('pb-visible');io.unobserve(e.target);}
      });
    },{threshold:.18});
    reveal.forEach(function(el){io.observe(el)});
  } else reveal.forEach(function(el){el.classList.add('pb-visible')});

  // Cargo bubbles: no fake values; just elegant explanatory interaction.
  document.querySelectorAll('.pb-cargo-bubble').forEach(function(btn){
    btn.addEventListener('click',function(){
      var was = btn.classList.contains('open');
      document.querySelectorAll('.pb-cargo-bubble').forEach(function(b){b.classList.remove('open')});
      if(!was) btn.classList.add('open');
    });
  });
});
